import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, userProfile, signOut, loading } = useAuth();

  const navigationItems = [
    { path: '/homepage', label: 'Home', icon: 'Home' },
    { path: '/account-dashboard', label: 'Dashboard', icon: 'LayoutDashboard' },
    { path: '/funding-portal', label: 'Funding', icon: 'Wallet' },
    { path: '/trading-interface', label: 'Trading', icon: 'TrendingUp' },
    { path: '/security-center', label: 'Security', icon: 'Shield' }
  ];

  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="header-logo-container">
            <Link to="/homepage" className="flex items-center gap-3">
              <div className="header-logo">
                <Icon name="Lock" size={24} color="#FFFFFF" />
              </div>
              <span className="header-brand-text">Kryptostash</span>
            </Link>
          </div>

          <nav className="header-nav">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`header-nav-link ${isActivePath(item?.path) ? 'active' : ''}`}
              >
                {item?.label}
              </Link>
            ))}
          </nav>

          <div className="header-actions">
            {!loading && (
              user ? (
                <>
                  <div className="hidden md:flex items-center gap-3 mr-4">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-secondary)] flex items-center justify-center">
                      <span className="text-white text-sm font-semibold">
                        {userProfile?.first_name?.charAt(0) || user?.email?.charAt(0)?.toUpperCase()}
                      </span>
                    </div>
                    <span className="text-sm text-[var(--color-foreground)]">
                      {userProfile?.first_name || user?.email?.split('@')?.[0]}
                    </span>
                  </div>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="LogOut"
                    iconPosition="left"
                    onClick={handleSignOut}
                  >
                    Sign Out
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="User"
                    iconPosition="left"
                    onClick={() => navigate('/login')}
                  >
                    Sign In
                  </Button>
                  <Button
                    variant="default"
                    size="sm"
                    onClick={() => navigate('/registration')}
                  >
                    Get Started
                  </Button>
                </>
              )
            )}
          </div>
        </div>
      </header>
      <button
        className="mobile-menu-button"
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
      </button>
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : 'closed'}`}>
        <div className="mobile-menu-content">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`mobile-menu-link ${isActivePath(item?.path) ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              <div className="flex items-center gap-3">
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </div>
            </Link>
          ))}
          <div className="mt-6 space-y-3">
            {!loading && (
              user ? (
                <>
                  <div className="flex items-center gap-3 p-3 bg-[var(--color-muted)] rounded-lg">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-secondary)] flex items-center justify-center">
                      <span className="text-white font-semibold">
                        {userProfile?.first_name?.charAt(0) || user?.email?.charAt(0)?.toUpperCase()}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-[var(--color-foreground)]">
                        {userProfile?.first_name || user?.email?.split('@')?.[0]}
                      </p>
                      <p className="text-xs text-[var(--color-muted-foreground)]">{user?.email}</p>
                    </div>
                  </div>
                  <Button
                    variant="outline"
                    fullWidth
                    iconName="LogOut"
                    iconPosition="left"
                    onClick={() => {
                      closeMobileMenu();
                      handleSignOut();
                    }}
                  >
                    Sign Out
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outline"
                    fullWidth
                    iconName="User"
                    iconPosition="left"
                    onClick={() => {
                      closeMobileMenu();
                      navigate('/login');
                    }}
                  >
                    Sign In
                  </Button>
                  <Button
                    variant="default"
                    fullWidth
                    onClick={() => {
                      closeMobileMenu();
                      navigate('/registration');
                    }}
                  >
                    Get Started
                  </Button>
                </>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;